import { PEV } from "../../../../../../common/utils";

export const emptyAppInfoTableContent = () => ({
  data: PEV({
    columns: [],
    dataSource: [],
  }),
  appId: null,
  gaaDataSource: [],
  aoDataSource: [],
  copyGaaEmails: "",
  copyAoEmails: "",
});

export const appInfoCalledBy = "appInfo";

export const findAppInfoTableContentIndexByAppId = (state, appId) =>
  state.appInfoTableContent.findIndex((rh) => rh.appId === appId);

export const findAppInfoTableContentById = (state, appId) =>
  state.appInfoTableContent.find((review) => review.appId === appId);

export const findLoadingState = (state, appId) =>
  state.appInfoTableContent?.find((review) => review.appId === appId)?.data?.progress;

export const findErrorState = (state, appId) =>
  state.appInfoTableContent?.find((review) => review.appId === appId)?.data?.error;

export const getCurrentModelState = () => window.store.getState().InfoTabUsersTableContent;

export const getAppInfoTotalColumns = (appId) =>
  getCurrentModelState().appInfoTableContent?.find((review) => review.appId === appId)?.data?.value
    ?.columns ?? [];

export function getUsersForAppInfoTabPendingState(state, pendingAction) {
  const appId = pendingAction.meta.arg.appId;
  const appInfoTableContentIndex = findAppInfoTableContentIndexByAppId(state, appId);
  const emptyAppInfoTableContents = { ...emptyAppInfoTableContent(), appId };
  emptyAppInfoTableContents.data.progress = "Fetching User Tab Table Content";
  if (appInfoTableContentIndex === -1) {
    state.appInfoTableContent.push(emptyAppInfoTableContents);
  } else {
    state.appInfoTableContent[appInfoTableContentIndex] = emptyAppInfoTableContents;
  }
}
export function getUsersForAppInfoTabSuccessState(state, action) {
  const appId = action.meta.arg.appId;
  const appInfoTableContentIndex = findAppInfoTableContentIndexByAppId(state, appId);
  state.appInfoTableContent[appInfoTableContentIndex].data = PEV(action.payload);
}
export function getUsersForAppInfoTabRejectedState(state, rejectedAction) {
  const appId = rejectedAction.meta.arg.appId;
  const appInfoTableContentIndex = findAppInfoTableContentIndexByAppId(state, appId);
  state.appInfoTableContent[appInfoTableContentIndex].data.progress = null;
  state.appInfoTableContent[appInfoTableContentIndex].data.error = rejectedAction.error;
}
